// React
import React from 'react';
import PropTypes from 'prop-types';

// VDS-React
import Tooltip from '@visa/vds-react/tooltip-styled';
// VDS-Tooltip is based on React Popper Tooltip and Popper.js library.
import classes from './component.styles';

const CybsTooltip = ({
  children,
  delayOff,
  delayOn,
  direction,
  isShown,
  label,
  showOn,
  dataTest,
  ...props
}) => {
  const getTooltipClass = cssInput =>
    classes(cssInput.classes, cssInput.variables).tooltip;

  return (
    <Tooltip
      css={getTooltipClass}
      data-test={`${dataTest}-cybsTooltip`}
      delayHide={delayOff}
      delayShow={delayOn}
      placement={direction}
      tooltip={label}
      tooltipShown={isShown}
      trigger={showOn}
      {...props}
    >
      {children}
    </Tooltip>
  );
};

CybsTooltip.propTypes = {
  /**
   * DataTest Label
   */
  dataTest: PropTypes.string.isRequired,

  /**
   * Content
   */
  children: PropTypes.node.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   *  Delay of the tooltip till which it should be hidden.
   */
  delayOff: PropTypes.number,

  /**
   * Delay of the tooltip till which it should show.
   */
  delayOn: PropTypes.number,

  /**
   * Position of the tooltip.
   */
  direction: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),

  /**
   * Whether or not the tooltip should be shown.
   * This is only used if we are controlling the component state with hooks.
   */
  isShown: PropTypes.bool,

  /**
   * Label of the tooltip.
   */
  label: PropTypes.node.isRequired,

  /**
   * Tooltip should show on mouse or hover
   */
  showOn: PropTypes.oneOf(['click', 'hover', 'none', 'right-click'])
};

CybsTooltip.defaultProps = {
  className: '',
  delayOff: 0,
  delayOn: 0,
  direction: 'top',
  isShown: undefined,
  showOn: 'hover'
};

CybsTooltip.displayName = 'CybsTooltip';

export default CybsTooltip;
